var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8416 9.99991L17.0916 4.75824C17.2485 4.60132 17.3367 4.3885 17.3367 4.16658C17.3367 3.94466 17.2485 3.73183 17.0916 3.57491C16.9347 3.41799 16.7219 3.32983 16.4999 3.32983C16.278 3.32983 16.0652 3.41799 15.9083 3.57491L10.6666 8.82491L5.42495 3.57491C5.26803 3.41799 5.0552 3.32983 4.83328 3.32983C4.61136 3.32983 4.39854 3.41799 4.24162 3.57491C4.0847 3.73183 3.99654 3.94466 3.99654 4.16658C3.99654 4.3885 4.0847 4.60132 4.24162 4.75824L9.49162 9.99991L4.24162 15.2416C4.16351 15.319 4.10151 15.4112 4.05921 15.5128C4.0169 15.6143 3.99512 15.7232 3.99512 15.8332C3.99512 15.9433 4.0169 16.0522 4.05921 16.1537C4.10151 16.2553 4.16351 16.3474 4.24162 16.4249C4.31908 16.503 4.41125 16.565 4.5128 16.6073C4.61435 16.6496 4.72327 16.6714 4.83328 16.6714C4.94329 16.6714 5.05221 16.6496 5.15376 16.6073C5.25531 16.565 5.34748 16.503 5.42495 16.4249L10.6666 11.1749L15.9083 16.4249C15.9858 16.503 16.0779 16.565 16.1795 16.6073C16.281 16.6496 16.3899 16.6714 16.4999 16.6714C16.61 16.6714 16.7189 16.6496 16.8204 16.6073C16.922 16.565 17.0141 16.503 17.0916 16.4249C17.1697 16.3474 17.2317 16.2553 17.274 16.1537C17.3163 16.0522 17.3381 15.9433 17.3381 15.8332C17.3381 15.7232 17.3163 15.6143 17.274 15.5128C17.2317 15.4112 17.1697 15.319 17.0916 15.2416L11.8416 9.99991Z",
    fill: "#DC3232"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close-red.5155401fa11eb28f8e7ef620cc560e82.svg";
export { ForwardRef as ReactComponent };